import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import { TextInput } from "../../../Helpers/Inputs";
import { InputMaskDate, NumberFormatDollars } from "../../../Helpers/Formatters";
import { KENTUCKY, FLORIDA, SOUTH_CAROLINA } from '../../../Helpers/Constants/States';

export default function InsurancePolicyForm(props) {

    const state = props.state;

    const onFieldChange = (field, value) => {
        // call onChange with the whole updated form
        props.onChange({ ...props.formState, [field]: value });
    }

    // manually call setValue for fields that don't play nice with react-hook-form register
    const handleValueChange = (field, value, longFieldName) => {
        onFieldChange(field, value);
        props.trigger(longFieldName);
    }

    return (
        <div>
            {((state === FLORIDA && props.replaceExistingCoverage === "Yes") || (state === KENTUCKY || state === SOUTH_CAROLINA)) &&
                <Fragment>
                    <p className="section-title">Insurance Policy {props.index + 1}</p>
                    <div className="mb-3">
                        <TextInput
                            name={`insurancePolicies[${props.index}].company`}
                            id={`insurancePolicies[${props.index}].company`}
                            label="Company Name"
                            value={props.formState.company}
                            onChange={(e) => handleValueChange('company', e.target.value, `insurancePolicies[${props.index}].company`)}
                        />
                    </div>
                </Fragment>
            }

            {((state === FLORIDA && props.replaceExistingCoverage === "Yes") || (state === KENTUCKY || state === SOUTH_CAROLINA)) &&
                <div className="mb-3">
                    <TextInput
                        name={`insurancePolicies[${props.index}].policyNumber`}
                        id={`insurancePolicies[${props.index}].policyNumber`}
                        label="Policy Number"
                        value={props.formState.policyNumber}
                        onChange={(e) => handleValueChange('policyNumber', e.target.value, `insurancePolicies[${props.index}].policyNumber`)}
                    />
                </div>
            }

            {(state === KENTUCKY) &&
                <div className="mb-3">
                    <TextInput
                        name={`insurancePolicies[${props.index}].faceAmount`}
                        id={`insurancePolicies[${props.index}].faceAmount`}
                        label="Benefit Amount"
                        value={props.formState.faceAmount}
                        onChange={(e) => handleValueChange('faceAmount', e.target.value, `insurancePolicies[${props.index}].faceAmount`)}
                        InputProps={{
                            inputComponent: NumberFormatDollars,
                        }}
                    />
                </div>
            }

            {(state === FLORIDA && props.replaceExistingCoverage === "Yes") &&
                <div className="mb-3">
                    <TextInput
                        name={`insurancePolicies[${props.index}].insuranceDate`}
                        id={`insurancePolicies[${props.index}].insuranceDate`}
                        label="Issue Date"
                        value={props.formState.insuranceDate}
                        onChange={(e) => handleValueChange('insuranceDate', e.target.value, `insurancePolicies[${props.index}].insuranceDate`)}
                        InputProps={{
                            inputComponent: InputMaskDate,
                        }}
                    />
                </div>
            }

            {state === SOUTH_CAROLINA &&
                <div className="mb-3">
                    <TextInput
                        name={`insurancePolicies[${props.index}].replaceExistingCoverageType`}
                        id={`insurancePolicies[${props.index}].replaceExistingCoverageType`}
                        label="Policy Type"
                        value={props.formState.replaceExistingCoverageType}
                        onChange={(e) => handleValueChange('replaceExistingCoverageType', e.target.value, `insurancePolicies[${props.index}].replaceExistingCoverageType`)}
                    />
                </div>
            }
        </div>
    )
}

InsurancePolicyForm.propTypes = {
    formState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
};
